// src/components/BookingPage.js
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

import Modal from '../modal/modal';
import {
  Container,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Button,
  Box,
  Card,
  CardContent,
} from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'; // Icon for the button
import Autocomplete from '../modal/AutoComplete';
import PhoneNumberField from '../modal/PhoneNumberField'

import '../CSS/styles.css'
import ApologizeModal from '../modal/ApologizeModal';

const BookingPage = () => {
  // State to hold the selected trip type
  const [tripType, setTripType] = useState('single');


    // State for all form fields
    const [customerName, setCustomerName] = useState('');
    const [openModal,setOpenModal] = useState(false);    
    const [phoneNumber, setPhoneNumber] = useState('');
    const [pickupLocation, setPickupLocation] = useState('');
    const [carModal, setCarModal] = useState('');
    
    // Single and Round trip specific fields
    const [dropLocation, setDropLocation] = useState('');
    const [pickupDateTime, setPickupDateTime] = useState('');
    
    // Round trip specific fields
    const [returnDateTime, setReturnDateTime] = useState('');
  
    // Tour-specific fields
    const [tourDestination, setTourDestination] = useState('');
    const [numberOfDays, setNumberOfDays] = useState('');
  
    const handlePhoneNumberChange = (newPhoneNumber) => {
      setPhoneNumber(newPhoneNumber); // Update state when value changes
    };
    // Handle form submission
    const handleSubmit = () => {
      const formData = {
        customerName,
        phoneNumber,
        pickupLocation,
        carModal,
        dropLocation: tripType !== 'tour' ? dropLocation : null,
        pickupDateTime,
        returnDateTime: tripType === 'round' ? returnDateTime : null,
        tourDestination: tripType === 'tour' ? tourDestination : null,
        numberOfDays: tripType === 'tour' ? numberOfDays : null,
      };
      console.log('Form Data:', formData);

      setOpenModal(true);


      // Submit or process the form data here (e.g., API call)
    };
  // Handle change in trip type selection
  const handleTripTypeChange = (event, newTripType) => {
    if (newTripType !== null) {
      setTripType(newTripType);
    }
  };

  // Render form based on selected trip type
  const renderForm = () => {
    return (
      <Card sx={{ mt: 3, backgroundColor: '#fff', maxWidth: 600 }}>
              <Helmet>
    <meta charset="UTF-8" />
 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
 <meta property="og:type" content="website" />
 <meta property="og:site_name" content="SVR Taxi Service | Call us 9965821750" />
 <meta charset="UTF-8" />
 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
 
 
 <meta property="og:locale" content="en_IN" />
        <meta property="og:url" content="https://svrtaxi.netlify.app/package"/>
        <meta property="og:image" content="https://svrtaxi.netlify.app/VisitingCard.jpg" />
 <meta name="description" content="Reliable, taxi, service, in Salem, and, across India. Available 24/7 with professional drivers and affordable pricing. Book now for a comfortable journey."/>
 <meta name="keywords" content="best cab service in salem ,Salem to Yercaud Taxi Service - Affordable Rides to the Scenic Hill Station,Salem to Tirupati Taxi - Comfortable Rides to the Sacred Temple Town, Salem to Bangalore Taxi Service - Fast and Reliable City Transfers,Salem to Madurai Taxi Service - Explore the Historic City with Ease,Salem to Coimbatore Taxi Service - Quick and Safe Transportation,
Salem to Ooty Taxi Service - Scenic Rides to the Queen of Hill Stations, Salem to Kodaikanal Taxi Service - Travel to the Princess of Hill Stations , Salem to Kanyakumari Taxi Service - Journey to the Southern Tip of India , Salem to Chennai Taxi Service - Efficient Transfers to Tamil Nadu’s Capital , Salem to Oganakkal Falls Taxi Service - Explore the Stunning Waterfalls , Salem to Mettur Dam Taxi Service - Comfortable Rides to the Historic Dam , Salem to Thanjavur Taxi Service - Explore the Cultural Capital of Tamil Nadu ,taxi ,service, Salem, India, airport, transfers, intercity, travel, taxi ,booking,svr taxi,Affordable, taxi ,service ,from ,Salem, to ,Chennai,Best, outstation, cab ,service, from ,Salem ,to ,Kodaikanal,Taxi ,service ,for ,day, trips, in ,and, around, Salem,One-way ,taxi ,service ,from ,Salem ,to ,Bangalore,Book ,a, cab, for ,Salem to ,Tiruchirappalli ,trip,Salem to ,Yercaud ,cab ,service for ,family ,trips,Reliable ,24-hour, taxi, service in Salem,Taxi booking, for airport transfers, in Salem,Safe, taxi, service ,for solo ,women, travelers ,in Salem,Outstation, cab, services ,from Salem ,for business ,trips,Affordable car ,rental ,for Salem, sightseeing,Affordable ,Salem to ,Ooty, weekend, tour ,packages,Salem to ,Munnar, taxi, service with sightseeing packages,Pilgrimage, taxi service from, Salem to ,Samayapuram, Temple,
    Budget ,taxi, packages, from Salem to ,Hogenakkal, Falls,Cab service for Salem to ,Kodaikanal, honeymoon, package,Luxury, taxi service, for ,corporate ,trips, from Salem to ,Chennai,Round-trip, taxi ,service ,from Salem to, Mysore,Car, rental, with, driver, for ,outstation trips, in ,Tamil Nadu,Customized, tour packages, with taxi service in Tamil Nadu,
    Cheap, cab ,service for ,outstation trips, from Salem, best, taxi service in salem , best , taxi , service , Best taxi service in salem , Best Cab service in salem,, contact us 9965821750 to book ride"/>
 <meta name="author" content="SVR Taxi" />
 <link rel="canonical" href="https://svrtaxi.netlify.app/booking" />
{/* {    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" type="image/x-icon" /> } */}

 <meta property="og:title" content="Just call and book the ride | Rs.8 Per km in salem" />
 <link rel="stylesheet" href="%PUBLIC_URL%/styles.css"/>
 <link rel="preconnect" href="https://fonts.googleapis.com"/>
 <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
 <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />

 
 </Helmet>
 
      <CardContent>
        <Typography variant="h1" gutterBottom sx={{fontSize:'larger' }}>
          {tripType === 'single' && 'Single Trip Booking'}
          {tripType === 'round' && 'Round Trip Booking'}
          {tripType === 'tour' && 'Tour Package Booking'}
        </Typography>

        {/* Common fields for all trip types */}
        <TextField
          fullWidth
          label="Customer Name"
          margin="normal"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
        />
        <PhoneNumberField
          value={phoneNumber}
          modal = {handlePhoneNumberChange}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
        <TextField
          fullWidth
          label="Pickup Location"
          margin="normal"
          value={pickupLocation}
          onChange={(e) => setPickupLocation(e.target.value)}
        />
        <Autocomplete
          label={"Select Car Model"}
          lookupName={"carModals"}
          value={carModal}
          onChange={(value) => setCarModal(value)} // Assuming Autocomplete returns a value
        />

        {/* Trip-specific fields */}
        {tripType === 'single' && (
          <>
            <TextField
              fullWidth
              label="Drop Location"
              margin="normal"
              value={dropLocation}
              onChange={(e) => setDropLocation(e.target.value)}
            />
            <TextField
              fullWidth
              label="Pickup Date and Time"
              type="datetime-local"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={pickupDateTime}
              onChange={(e) => setPickupDateTime(e.target.value)}
            />
          </>
        )}

        {tripType === 'round' && (
          <>
            <TextField
              fullWidth
              label="Drop Location"
              margin="normal"
              value={dropLocation}
              onChange={(e) => setDropLocation(e.target.value)}
            />
            <TextField
              fullWidth
              label="Pickup Date and Time"
              type="datetime-local"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={pickupDateTime}
              onChange={(e) => setPickupDateTime(e.target.value)}
            />
            <TextField
              fullWidth
              label="Return Date and Time"
              type="datetime-local"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={returnDateTime}
              onChange={(e) => setReturnDateTime(e.target.value)}
            />
          </>
        )}

        {tripType === 'tour' && (
          <>
            <TextField
              fullWidth
              label="Tour Destination"
              margin="normal"
              value={tourDestination}
              onChange={(e) => setTourDestination(e.target.value)}
            />
            <TextField
              fullWidth
              label="Pickup Date and Time"
              type="datetime-local"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={pickupDateTime}
              onChange={(e) => setPickupDateTime(e.target.value)}
            />
            <TextField
              fullWidth
              label="Number of Days"
              type="number"
              margin="normal"
              value={numberOfDays}
              onChange={(e) => setNumberOfDays(e.target.value)}
            />
          </>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<DirectionsCarIcon />}
            onClick={handleSubmit}  // Handle form submission
          >
            Book {tripType === 'tour' ? 'Tour Package' : 'Trip'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );

  };

  return (

    <>
    {openModal && (
      <Modal heading={"Network Issue"} action={openModal}>
        <ApologizeModal />
      </Modal>
    )}
    <Container sx={{marginBottom:10}} className='ride-booking-form'>
      <Typography variant="h4" align="center" gutterBottom>
        Book Your Ride
      </Typography>

      {/* ToggleButtonGroup for selecting trip type */}
      <ToggleButtonGroup
        value={tripType}
        exclusive
        onChange={handleTripTypeChange}
        aria-label="Trip Type"
        sx={{ mb: 0 }}
      >
        <ToggleButton value="single" aria-label="Single Trip">
          Single Trip
        </ToggleButton>
        <ToggleButton value="round" aria-label="Round Trip">
          Round Trip
        </ToggleButton>
        <ToggleButton value="tour" aria-label="Tour Package">
          Tour Package
        </ToggleButton>
      </ToggleButtonGroup>

      {/* Render the appropriate form based on selected trip type */}
      {renderForm()}
    </Container>
    </>
  );
};

export default BookingPage;
